import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {EntidadeService} from 'src/app/api/module/erp/services/area-logada/entidade/entidade.service';
import {EnumService} from 'src/app/api/module/erp/services/area-logada/enum/enum.service';
import {CepFormService} from 'src/app/api/module/erp/services/consultaCEP/cep-form-service.service';
import {GeoLocalizacaoService} from 'src/app/api/module/erp/shared/geo-localizacao/geo-localizacao.service';
import {ListaAuxiliaresService} from 'src/app/api/module/erp/shared/lista-auxiliares/lista-auxiliares.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {VerificaEmail} from 'src/app/components/helper/form-validators/verifica-email';
import {EnderecoComponent} from 'src/app/pages/area-logada/shared/components/endereco/endereco.component';

@Component({
  selector: 'app-formulario-inscricao-entidade-adservip',
  templateUrl: './formulario-inscricao-entidade-adservip.component.html',
  styleUrls: ['./formulario-inscricao-entidade-adservip.component.scss'],
})
export class FormularioInscricaoEntidadeAdservipComponent implements OnInit, OnChanges {
  @ViewChild(EnderecoComponent) enderecoComponent: EnderecoComponent;

  podeCadastrar: any = false;

  @Output() aoFecharModalInscricao = new EventEmitter<boolean>();
  formularioInscricaoEntidade!: FormGroup;
  ListaServidores!: any;
  bsConfig!: Partial<BsDatepickerConfig>;
  listaEstatusCivil = new Array<any>();
  minDate!: Date;
  maxDate!: Date;
  isFormSubmited: boolean = false;
  listaCidades = new Array<any>();
  listaEstados = new Array<any>();
  formTouched: boolean = false;
  errorMessage: boolean = false;
  idProposta: string = '';
  @Input() retornoDadosFormularioEntidade: any;
  @Input() nomeEntidade: string = 'ADSERVIP';
  @Input() formEntidadeSomenteLeitura: boolean = false;
  mostrarFormulario!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private _listaAux: ListaAuxiliaresService,
    private _enumServices: EnumService,
    private _errorLoggingService: ErrorLoggingService,
    private _spinnerService: SpinnerService,
    private bsLocaleService: BsLocaleService,
    private _cepFormService: CepFormService,
    private _geo: GeoLocalizacaoService,
    private toastr: ToastrService,
    private _entidadeService: EntidadeService,
    private _activeRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
    this.bsLocaleService.use('pt-br');
    this.minDate = new Date(1900, 0, 1);
    this.maxDate = new Date();
    this.bsConfig = {
      isAnimated: true,
      dateInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      adaptivePosition: true,
      maxDate: new Date(),
    };
    this.criarFormularioInscricaoEntidade();
  }

  ngOnInit(): void {
    this.buscarEnums();
    this.buscarListaEstatusCivil();
    if (this.formEntidadeSomenteLeitura) {
      this.formularioInscricaoEntidade.disable(); // torna todo formulário somente leitura
      this.enderecoComponent?.enderecoForm.disable();
    } else {
      this.formularioInscricaoEntidade.enable();
      this.enderecoComponent?.enderecoForm.enable();
    }
    this.idProposta = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['retornoDadosFormularioEntidade'] && changes['retornoDadosFormularioEntidade'].currentValue) {
      this.carregarDadosNoFormulario(this.retornoDadosFormularioEntidade);
    }
  }

  private carregarDadosNoFormulario(dados: any) {
    if (!dados) {
      return;
    }

    if (!this.formularioInscricaoEntidade) {
      this.criarFormularioInscricaoEntidade();
    }

    // Preenche o formulário
    try {
      this.formularioInscricaoEntidade.patchValue({
        proposalId: dados.proposalId || '',
        civilStatusId: dados.civilStatusId || '',
        server: dados.server || null,
        name: dados.name || '',
        birthDate: new Date(dados.birthDate) || '',
        cpf: dados.cpf || '',
        rg: dados.rg || '',
        email: dados.email || '',
        sex: dados.sex || null,
        businessPhone: dados.businessPhone || '',
        homePhone: dados.homePhone || '',
        mobilePhone: dados.mobilePhone || '',
      });

      setTimeout(() => {
        this.enderecoComponent.preencherFormComponenteSemTabela(dados);
      }, 100);
      this.cdRef.detectChanges();
    } catch (error) {}
  }

  private criarFormularioInscricaoEntidade() {
    this.formularioInscricaoEntidade = this.formBuilder.group({
      proposalId: ['', Validators.required],
      civilStatusId: ['', Validators.required],
      server: [null, [Validators.required]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      birthDate: ['', Validators.required],
      cpf: ['', [Validators.required]],
      rg: ['', Validators.required],
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.minLength(2),
        Validators.maxLength(250),
        VerificaEmail,
      ]),
      sex: [null, [Validators.required]],
      businessPhone: [''],
      homePhone: [''],
      mobilePhone: ['', Validators.required],
    });
  }

  buscarEnums() {
    this.iniciarSpinner();
    this._enumServices
      .getEnumsProposta()
      .pipe(
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe(data => {
        const listaServidoresDM = data.filter((x: any) => x.enumType === 'ServersEnum');

        if (listaServidoresDM.length > 0) {
          this.ListaServidores = listaServidoresDM[0].values;
        } else this.ListaServidores = 0;
      });
  }

  buscarListaEstatusCivil() {
    this._listaAux.LitaEstadosCivil().subscribe(data => {
      this.listaEstatusCivil = data && data;
    });
  }

  fechar(): void {
    // Marca todos os campos como tocados para validar
    this.marcarCamposComoTocados();
    // Verifica se foi preenchido (dirty) E válido
    const formularioPreenchidoEValido =
      this.formularioInscricaoEntidade.dirty && this.formularioInscricaoEntidade.valid;
    this.aoFecharModalInscricao.emit(formularioPreenchidoEValido);
  }

  private marcarCamposComoTocados(): void {
    Object.keys(this.formularioInscricaoEntidade.controls).forEach(campo => {
      this.formularioInscricaoEntidade.get(campo)?.markAsTouched();
    });
  }

  salvar() {
    this.iniciarSpinner();
    this.formTouched = true;
    this.formularioInscricaoEntidade.get('proposalId')?.patchValue(this.idProposta);

    if (this.enderecoComponent) {
      this.enderecoComponent.formTouched = true;
      this.enderecoComponent.isFormSubmited = true;
      this.enderecoComponent.showErrorMessage = true;
    }

    if (!this.formularioInscricaoEntidade.valid) {
      this.isFormSubmited = true;
      this.toastr.warning('Por favor, verificar todos os campos obrigatórios');
      this.toastr.toastrConfig.preventDuplicates = true;
      this.pararSpinner();
      return;
    }

    const formEndereco = this.enderecoComponent?.isFormValid() ?? true;
    if (!formEndereco) {
      this.toastr.warning('Por favor, verifique todos os campos obrigatórios.');
      this.toastr.toastrConfig.preventDuplicates = true;
      this.pararSpinner();
      return;
    }
    const formularioEnderco = this.enderecoComponent?.enderecoForm.value;
    delete formularioEnderco['id'];
    delete formularioEnderco['active'];

    const formData = {
      ...this.formularioInscricaoEntidade.value,
      ...formularioEnderco,
    };
    this._entidadeService
      .cadastrarFormEntidadePorProposta(formData)
      .pipe(finalize(() => this.pararSpinner(1000)))
      .subscribe({
        next: async (data: any) => {
          this.toastr.success('Dados Cadastrados!');
          this.aoFecharModalInscricao.emit(true);
        },
        error: (e: any) => {
          this.toastr.toastrConfig.preventDuplicates = true;
          this.toastr.error(e.mensagemTratada);
          this.pararSpinner();
        },
      });
  }

  isFormValid() {
    this.isFormSubmited = true;
    return this.formularioInscricaoEntidade.valid;
  }

  onFieldChange() {
    if (this.formTouched) {
      this.errorMessage = !this.isFormValid();
    }
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }
}
